import mergeWith from 'lodash/mergeWith';
import { isObservable } from 'mobx';

export default function ssrProps(compId, allProps, newProps) {
  let props
  if(compId && allProps) {
    props = allProps[compId]
    if(!props) {
      const id = compId.match(/(.*)\_\d+$/)?.[1]
      props = id && allProps[id]
    }
  } else {
    return newProps
  }

  if(newProps) {
    return mergeWith({}, props || {}, newProps || {}, (dest, src) => {
      if(isObservable(src)) return src
      if(Array.isArray(dest)) return src
    })
  }
  
  return props
}
